import { Component, inject } from '@angular/core'
import { RouterOutlet } from '@angular/router'
import { DOCUMENT } from '@angular/common'

import { Fade } from '@animations/fades.animations'
import { OperatorDataState } from '@states/operator-data'

@Component({
	selector: 'cp-validate',
	template: `<router-outlet />`,
	animations: [Fade],
	imports: [RouterOutlet],
})
export class AppComponent {
	readonly #document = inject(DOCUMENT)
	readonly #operatorDataState = inject(OperatorDataState)

	readonly isCurbstand = this.#operatorDataState.isCurbstand

	constructor() {
		const isCurbstand = this.#operatorDataState.isCurbstand()

		if (isCurbstand) {
			this.#document.body.classList.add('curbstand-theme')
		} else {
			this.#document.body.classList.remove('curbstand-theme')
		}
	}
}
